import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";

@engineComponent(ComponentTypes.Style)
export class ProtonStyle extends Style {
    node: Element;

    constructor() {
        super();
    }

    create(node: Element) {
        super.create(node);

        this.node = node;
    }
}

export const ProtonStyleAttributes = {
    BEHAVIOUR_ROTATE: {
        /**
         * When style is 'to': Starting rotational speed
         * When style is 'add': Starting angle
         */
        START: "Start",
        /**
         * When style is 'to': Finishing rotation speed
         * When style is 'add': Rotational speed
         */
        END: "End",
        /**
         * If 'to', 'To' or '_' is omitted for style, it will be 'to'.
         */
        STYLE: "Style",
    },
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/ProtonStyle.ts
 **/